import type {
  ArticleReadActionReturnType,
  BuyPrizeElementResponseType,
  CampaignOrderData,
  CustomerPointsHistoryResponseType,
  CustomerReferralHistoryResponseType,
  GetAchievementsResponse,
  GetArticlesPayloadType,
  GetArticlesResponseType,
  GetEligibleCampaignsResponseType,
  GetPointsResponseType,
  GetPrizesInputType,
  GetPrizesResponseType,
  GetProductPointsReturnType,
  GetQrCodeDetailsPayload,
  GetQrCodeDetailsResponseType,
  GetRewardFiltersResponseType,
  GetTiersResponseType,
  GetUserTierDataResponseType,
  GetUserTierResponseType,
  QuizCompleteActionReturnType,
  ScanQrActionReturnType,
  VideoWatchActionReturnType,
} from "@jti/rest-api-types";

import type { RestResponseType } from "../Rest";

export type LoyaltySummaryResponse = {
  points: GetPointsResponseType;
  tier: GetUserTierResponseType | null;
};

export interface LoyaltyApiContact {
  getArticles(payload: GetArticlesPayloadType): Promise<GetArticlesResponseType>;
  getStatus(): Promise<boolean>;
  getPoints(uuid: string, ciam_token: string, useLocalCache?: boolean): Promise<GetPointsResponseType>;
  getLoyaltySummary(uuid: string, ciam_token: string, useLocalCache?: boolean): Promise<LoyaltySummaryResponse>;
  getProductPoints(
    sku: string,
    quantity: number,
    uuid?: string | null,
    ciam_token?: string | null
  ): Promise<GetProductPointsReturnType>;
  getEligibleCampaigns(
    uuid: string,
    ciam_token: string,
    order?: CampaignOrderData
  ): Promise<GetEligibleCampaignsResponseType[]>;
  getPointsHistory(
    consumer_uuid: string,
    ciam_token: string,
    perPage?: number,
    page?: number
  ): Promise<CustomerPointsHistoryResponseType>;
  getReferralHistory(
    consumer_uuid: string,
    ciam_token: string,
    perPage?: number,
    page?: number
  ): Promise<CustomerReferralHistoryResponseType>;
  getTiers(): Promise<RestResponseType<GetTiersResponseType[]>>;
  getUserTierData(consumer_uuid: string, ciam_token: string): Promise<RestResponseType<GetUserTierDataResponseType>>;
  getEarnedPoints(order_id: string, ciam_token: string, uuid?: string): Promise<number>;
  getPrizes(payload: GetPrizesInputType): Promise<RestResponseType<GetPrizesResponseType>>;
  buyPrize(
    consumer_uuid: string,
    prize_uuid: string,
    qty: number,
    ciam_token: string
  ): Promise<RestResponseType<BuyPrizeElementResponseType>>;
  getEarningRulePoints(event_name: string, ciam_token: string, user_uuid: string): Promise<number>;
  getUserTier(consumer_uuid: string, ciam_token: string): Promise<GetUserTierResponseType>;
  getQrCodeDetails(payload: GetQrCodeDetailsPayload): Promise<GetQrCodeDetailsResponseType>;
  readArticleAction(article_id: string, ciam_token: string): Promise<ArticleReadActionReturnType>;
  watchVideoAction(uuid: string, video_id: string): Promise<VideoWatchActionReturnType>;
  scanQrAction(qr_id: string, ciam_token: string, uuid?: string): Promise<ScanQrActionReturnType>;
  getAchievements(uuid: string, ciam_token: string): Promise<GetAchievementsResponse>;
  completeQuizAction(quiz_id: string, uuid: string): Promise<QuizCompleteActionReturnType>;
  getRewardFilters(): Promise<GetRewardFiltersResponseType>;
}
